import { t } from 'i18next';

// The backend stores a Rutter failure as a Ruby hash dump, e.g.
// `450: {"error_code" => "...", "error_metadata" => {"human_readable" => "..."}}`
const quotedHashValue = String.raw`\s*(?:=>|:)\s*"((?:[^"\\]|\\.)*)"`;
const humanReadablePattern = new RegExp(`"human_readable"${quotedHashValue}`);
const errorMessagePattern = new RegExp(`"error_message"${quotedHashValue}`);

const sharedConnectionErrorMessageKeys = {
  shared_connection_currency_mismatch:
    'error_messages.rutter.shared_connection_currency_mismatch',
  shared_connection_in_use: 'error_messages.rutter.shared_connection_in_use',
  shared_connection_unavailable: 'error_messages.rutter.shared_connection_unavailable',
} satisfies Record<string, string>;

export const getRutterExportErrorMessage = (lastError: string) => {
  const sharedConnectionError = Object.entries(sharedConnectionErrorMessageKeys).find(
    ([errorCode]) => lastError.includes(errorCode),
  );
  if (sharedConnectionError) {
    const [, messageKey] = sharedConnectionError;

    return t(messageKey);
  }

  const match =
    humanReadablePattern.exec(lastError) ?? errorMessagePattern.exec(lastError);
  const message = match?.[1];

  return message ? message.replace(/\\(["\\])/g, '$1') : lastError;
};
